






















import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../domain";

@Component({
  components: {
  },
})
export default class ResetAccountPasswordEntryView extends Mixins() {
  data() {
    return {
      isProcessing: false,
      isCompleted: false,
      accountCode: "",
    };
  }
  isProcessing: boolean;
  isCompleted: boolean;
  accountCode: string;
  
  async entry(): Promise<void> {
    try {
      if (!this.accountCode) {
        this.$warn("パスワード再設定", "ログインID（メールアドレス）を入力してください。");
        return;
      }
      // TODO: メールアドレスの正規表現はさらに厳密にする余地がある
      if (!/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9_.+-]+$/.test(this.accountCode)) {
        this.$warn("パスワード再設定", "ログインIDにメールアドレスを入力してください。");
        return;
      }
      const isConfirmed = await this.confirmResetPassword();
      if (!isConfirmed) { return; }

      this.isProcessing = true;
      const repo = DomainRegistry.account.getUnauthenticatedAccountRepository();
      const result = await repo.registerAccountPasswordResetEntry(this.accountCode);
      if (result.isAccountCodeInvalid) {
        // TODO: メールアドレスの存在確認のために対象にAPI叩かれた時の対策
        // 登録されているかどうかはフロントエンドに返さないほうがよい？
        this.$warn("パスワード再設定", "指定のログインIDは登録されていません。");
        return;
      }
      if (result.isMailSendFailed) {
        this.$warn("パスワード再設定", "メール送信処理中にエラーが発生しました。");
        return;
      }
      if (!result.isOk) {
        this.$warn("パスワード再設定", "メールを送信することができませんでした。");
        return;
      }
      this.$success("パスワード再設定", "メールを送信しました。");
      this.isCompleted = true;
    } catch (e) {
      this.$error("パスワード再設定", "処理中にエラーが発生しました。", e);
    } finally {
      this.isProcessing = false;
    }
  }

  private async confirmResetPassword(): Promise<boolean> {
    try {
      const index = await this.$commonDialogs.confirmation.confirmCancel(
        "パスワード再設定",
        ["指定のメールアドレスにパスワードを再設定するための確認メールを送信してもよろしいですか？"],
        "送信する"
      );
      return (index === 0);
    } catch (e) {
      return false;
    }
  }

  moveToLoginView(): void {
    this.$router.replace({
      path: "/Login",
    });
  }
}
